// -----------------------------------------------------------------------
// <copyright file="SupportOptionsHeader.tsx" company="Microsoft">
//     copyright (c) Microsoft. All rights reserved.
// </copyright>
// -----------------------------------------------------------------------

import { Icon, mergeStyles } from '@fluentui/react';
import React from 'react';
import { IconNames } from '../../../web-legacy/models/constants/constants';
import { commonClassNames } from '../../../web-legacy/packages/contactUs/styles/commonStyles';
import {
  getContactUsClassNames,
  getContactUsStyles,
} from '../../../web-legacy/packages/contactUs/styles/contactUsStyles';
import { IContactUsCurrentTheme } from '../../../web-legacy/packages/contactUs/styles/theme.model';
import { getPullRightClassName } from '../../../web-legacy/utilities';
import { getString } from '../../utils/stringLoader';

interface IProps {
  header: string;
  isCollapsedModalities: boolean;
  isAgave: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateModalitySectionExpando: (isCollapsedModalities: boolean) => any;
  isRtl: boolean;
  theme: IContactUsCurrentTheme;
  isSignUp: boolean;
}

export const SupportOptionsHeader = (props: IProps) => {
  const expandoChevron = props.isCollapsedModalities ? IconNames.ChevronDown : IconNames.ChevronUp;
  const behavior = props.isCollapsedModalities ? 'EXPAND' : 'REDUCE';

  const changeCollapseState = () => {
    props.updateModalitySectionExpando(!props.isCollapsedModalities);
  };

  const contactUsClassNames = getContactUsClassNames(getContactUsStyles, {
    theme: props.theme,
    isAgave: props.isAgave,
    isSignUp: props.isSignUp,
  });

  return (
    <a
      tabIndex={0}
      id="modalitiesExpando"
      data-bi-bhvr={behavior}
      data-bi-name="modalitiesExpando"
      data-bi-area="modalitiesSection"
      data-bi-formnm="maxFunnel"
      className="text-dark"
      onClick={() => {
        changeCollapseState();
      }}
      onKeyPress={(event: React.KeyboardEvent<HTMLAnchorElement>) => {
        if (event.key === 'Enter') {
          changeCollapseState();
        }
      }}
      aria-label={getString('supportOptionsHeader_text')}
    >
      <div className={contactUsClassNames.panelHeading}>
        <div id="modalitiesHeader" className={mergeStyles(commonClassNames.inline, contactUsClassNames.h2)}>
          <>{props.header}</>
        </div>
        <Icon
          aria-expanded={!props.isCollapsedModalities}
          className={mergeStyles(contactUsClassNames.arrow, getPullRightClassName(props.isRtl))}
          iconName={expandoChevron}
        />
      </div>
    </a>
  );
};
